import { PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { jwtDecode } from 'jwt-decode';
import {
  IClientResult,
  IJwtLinkShieldSessionSchema,
  JwtLinkShieldSessionSchema,
} from 'appwiki-link-shield-proxy';
import { ExecuteType, ITestProvider } from './loadingBarReducer';

export const LinkShieldSession = z
  .string()
  .optional()
  .transform((token, ctx) => {
    if (!token) {
      ctx.addIssue({
        code: 'custom',
        message: 'Link shield session is missing',
      });
      return z.NEVER;
    }

    const result = JwtLinkShieldSessionSchema.safeParse(jwtDecode(token));
    if (!result.success) {
      result.error.issues.forEach((issue) => ctx.addIssue(issue));
      return z.NEVER;
    }

    return result.data;
  });

export type ILinkShieldSessionLoaded =
  PayloadAction<IJwtLinkShieldSessionSchema>;

export type IRunTriggerFn = (
  triggerType: ExecuteType,
) => Promise<IClientResult>;

export type ITestRunned = PayloadAction<{
  provider: ITestProvider<IRunTriggerFn>;
}>;

export const RedirectResponse = z.object({
  redirect: z.string().check(z.url()),
});

export type IRedirectStarted = PayloadAction<z.infer<typeof RedirectResponse>>;
